<!--
     <IndicatorMetricInput
       :props="my_attrs_dictionary"
     />

     Public propertys:
       value → Gives the field's serializable value

     Public methods:
       validate → Makes validation and returns if the value is valid

     Accepted props:
   - value
   - size
   - label
   - required
   - readonly
   - class
   - disabled
   - default_weight
   - allowed_types
   - maximum_metrics
-->

<template>
  <v-input
    v-model="metrics"
    :rules="rules"
    @change="update"
  >
  <div class="imi-cont">
    <header class="imi">
      <h1 class="imi">{{ props.label }}</h1>

      <v-btn
        color="primary"
        small
        rounded
        class="add-button-fab explorer-header-component elevation-1"
        @click="add_metric"
        :elevation="1"
        :disabled="props.disabled"
      >
        <span>{{ $t('add') }}</span>
        <v-icon >mdi-plus</v-icon>
      </v-btn>
    </header>

    <div class="imi-list" :key="vue_update">
      <div
        :class="'imi-metric' + (props.disabled ? ' disabled' : '')"
        v-for="mt of metrics"
        :key="mt.id"
        @click="props.disabled || edit_metric(mt.id)"
      >
        <div class="imi-metric-id">{{ mt.id + 1 }}</div>
        <div class="imi-metric-weight">{{ $t('indicators.weight') }}: {{ mt.weight }}</div>
        <div class="imi-metric-name">{{ mt.name }}</div>
        <div class="imi-metric-type">{{ type_to_name(mt.type) }}</div>
        <div class="spacer"></div>
        <v-btn @click.stop="delete_metric(mt.id)" :disabled="props.disabled">x</v-btn>
      </div>
    </div>

    <MetricEditModal
      :title_prefix="props.label"
      :fix_type="metric_edit_fix_type"
      :metrics="{id: -1}"
      :current_unit="props.current_unit"
      ref="metric_edit_modal"
      :allowed_types="props.allowed_types"
      @save="save_metric"
    />
  </div>
  </v-input>
</template>

<style lang="scss">
 @import '@/sass/modalform.scss';
 @import "@/sass/variables.scss";

 .imi-cont {
   width: 100%;
   border-style: solid;
   border-width: 1px;
   border-color: $primary;
   border-radius: 5px;
   display: flex;
   flex-direction: column;
   padding: 8px;
   gap: 10px;
 }

 header.imi {
   display: flex;
   flex-direction: row;
   width: 100%;
   align-items: center;
   justify-content: space-between;
 }

 h1.imi {
   font-size: 1.2em;
   font-weight: normal;
 }

 .imi-list {
   display: flex;
   flex-direction: column;
   gap: 10px;
 }

 .imi-metric {
   width: 100%;
   border-style: solid;
   border-width: 1px;
   border-color: $primary;
   border-radius: 5px;
   display: flex;
   flex-direction: row;
   padding: 8px;
   justify-content: flex-start;
   align-items: center;
   gap: 10px;
   box-shadow: none;
   transition: box-shadow .2s;
 }

 .imi-metric:hover {
   box-shadow:
     0 3px 1px -2px rgba(0,0,0,.2),
     0 2px 2px 0 rgba(0,0,0,.14),
     0 1px 5px 0 rgba(0,0,0,.12) !important;
   cursor: pointer;
 }

 .imi-metric.disabled {
   box-shadow: none !important;
   cursor: default !important;
   border-color: #e0e0e0;
 }

 .imi-metric > span {
   display: block;
 }

 .imi-metric-id {
   width: 32px;
   color: #444;
 }

 .imi-metric-type {
   font-style: italic;
   color: #a40;
 }

 .imi-metric-weight {
   // width: 72px;
   font-weight: bold;
 }

 imi.button {
   
 }
</style>

<script>
 import MetricEditModal from '@/components/indicator/MetricEditModal';
 import { TYPES_NAMES } from '@/utils/indicator.js';

 let vue_counter = 1;

 export default {
   name: 'IndicatorMetricInput',

   props: ['props', 'required_rule'],

   components: { MetricEditModal },

   data: () => ({
     valid: true,
     metrics: [],
     metric_edit_fix_type: false,
     vue_update: 0,
   }),

   mounted() {
     console.log('🙄🙄', this.props.value, this);
     this.pull_from_value(this.props.value);
     this.vue_update = vue_counter++;
   },

   computed: {
     value() {
       return this.serialize();
     },

     props_value() {
      return this.props.value;
     },

     metric_edit_modal() {
       return this.$refs.metric_edit_modal;
     },

     rules() {
       return [(value) => (
         (!!value && value.length > 0)
         || !this.props.required
         || this.$t('required_field')
       )]
     },
   },

   methods: {
     validate() {
       return this.valid; // TODO
     },

     pull_from_value(val) {
       this.metrics = Array.from(val || []);
     },

     serialize() {
       return Array.from(this.metrics);
     },

     add_metric() {
       this.metric_edit_fix_type = false;
       this.metric_edit_modal.launch({id: -1});
     },

     edit_metric(mid) {
       this.metric_edit_fix_type = true;
       this.metric_edit_modal.launch(this.metrics[mid]);
     },

     delete_metric(mid) {
       this.metrics.splice(mid, 1);

       // Update the id of next metrics
       // TODO: ONLY DO THIS IF IS A NEW METRIC. YOU CAN'T DELETE METRICS FROM INITIAL VALUE
       for (let i = mid; i < this.metrics.length; i++) {
         this.metrics[i].id = i;
       }
     },

     save_metric(mconf) {
       if (mconf.id < 0) {
         mconf.id = this.metrics.length;
         this.metrics.push(mconf);
       } else {
         this.metrics[mconf.id] = mconf; // TODO: Vue reactivity?
       }
       this.props.value = this.metrics;
       this.vue_update = vue_counter++;
       this.update(this.serialize());
     },

     is_required(value) {
       return (
         !!value
         || !this.props.required
         || this.$t('required_field')
       );
     },

     error_state(ok) {
       this.valid = ok;
     },

     type_to_name(ty) {
       return TYPES_NAMES[ty];
     },

     update(value) {
       console.log('🙄🙄 update', value);
       this.$emit('update', value);
     },
   },

   watch: {
    props_value() {
      if (!this.props_value) {
        this.pull_from_value(this.props_value)
      }
    },
   },
 }
</script>
